export { default } from './Etiquetes';
